@import '~style-sheet-helpers/core';
@import '../../../../app-brand/entities/entity-layer.module.less';

.heavier () {
  font-weight: @bold;
}

.header-row {
  position: sticky;
  top: 0;

  [data-column] {
    align-items: center;
    background-color: transparent;
    box-sizing: border-box;
    color: @hooks-display-grid--header-row--text-color;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    height: 30px;
    justify-content: space-between;
    line-height: 30px;
    padding: 0 10px;
    position: relative;
    white-space: nowrap;

    &.sorted {
      background-color: @hooks-display-grid--header-row--sorted--background-color;
      .heavier();
      svg {
        fill: @hooks-display-grid--header-row--sorted--icon-color;
      }
    }

    &:last-child {
      border-right: 1px solid @hooks-display-grid--header-row--border-color;
    }
  }

  .checkbox {
    justify-content: flex-end;
  }
}

.flex {
  background-color: @hooks-display-grid--header--background-color;
  border-bottom: 1px solid @hooks-display-grid--header--border-color;
  display: flex;
  min-width: 100%;

  &.has-active-groupbys {
    background-color: @hooks-display-grid--header--has-active-group-bys--background-color;
    margin-right: 10px;
    box-shadow: 1px 0 1px @hooks-display-grid--header--has-active-group-bys--box-shadow-color;

    [data-column]:last-child {
      border: none;
      color: @hooks-display-grid--header--has-active-group-bys--last-child--text-color;

      &.is-active-groupby {
        background-color: @hooks-display-grid--header--has-active-group-bys--last-child--is-active-group-by--background-color;
        color: @hooks-display-grid--header--has-active-group-bys--last-child--is-active-group-by--text-color;
        .heavier();

        svg {
          fill: @hooks-display-grid--header--has-active-group-bys--last-child--is-active-group-by--icon-color;
        }
      }
    }
  }
}
